import React, { useCallback } from 'react';

import SteppedModal, { SteppedModalProps } from 'components/SteppedModal';

export type BlueskyPostModalProps = Pick<
  SteppedModalProps,
  | 'show'
  | 'title'
  | 'defaultStep'
  | 'steps'
  | 'footerButtonsDisabled'
  | 'onStepChange'
  | 'onExited'
> & {
  className?: string;
  onHide?: () => void;
};

const BlueskyPostModal = React.forwardRef<SteppedModal, BlueskyPostModalProps>(
  (
    {
      show,
      title,
      defaultStep,
      steps,
      footerButtonsDisabled,
      className,
      onStepChange,
      onHide,
      onExited,
    },
    ref,
  ) => {
    const handleHide = useCallback(() => {
      onHide();
    }, [onHide]);

    return (
      <SteppedModal
        {...{
          ref,
          show,
          title,
          defaultStep,
          steps,
          footerButtonsDisabled,
          onStepChange,
          onExited,
        }}
        baseClassName={className}
        onHide={handleHide}
      />
    );
  },
);

export default BlueskyPostModal;
